import {AbstractPricingItemSummaryMapper} from "../../abstract-pricing-item-summary.mapper";
import {PricingItem} from "../../../../../../domain/in/quote/pricing-item/pricing-item";
import {DevicePricingItem} from "../../../../../../domain/in/quote/pricing-item/device-pricing-item";
import {PricingItemSummary} from "../../../../../../domain/out/pricing-item-summary";
import {MappingContext} from "../../mapping-context";

export class FrAcLsSynthesisMapper extends AbstractPricingItemSummaryMapper {

    protected async doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary> {
        let devicePricingItem = pricingItem as DevicePricingItem;
        let pricingItemSummary = new PricingItemSummary();

        pricingItemSummary.codeElis = await ctx.resolveCodeElis(devicePricingItem.device.codeElis);
        pricingItemSummary.label = devicePricingItem.device.label;
        pricingItemSummary.quantity = devicePricingItem.userInputs.quantity;
        pricingItemSummary.appliedPrice = ctx.formatAmount(devicePricingItem.device.appliedPrice);
        pricingItemSummary.totalAppliedPrice = ctx.formatAmount(devicePricingItem.totalAppliedPrice);
        pricingItemSummary.frequency = await ctx.getFrequency(devicePricingItem);
        pricingItemSummary.exchangeRule = devicePricingItem.userInputs.exchangeRule.value;
        pricingItemSummary.initialStockLS = devicePricingItem.initialStockLS;
        pricingItemSummary.initialstockBillLS = ctx.formatAmount(devicePricingItem.initialstockBillLS);

        return pricingItemSummary;

    }

}
